<template>
  <div id="app">
    <h2>智能业绩佐证管理系统</h2>
    <video width="75%" height="75%" controls>
      <source src="./assets/demo.mp4" type="video/mp4">
      
    </video>
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
body{
  background-image: url("./assets/4.jpeg");
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue